<template>
    <div class="box-body" :style="'margin-bottom: '+footbottom+'px;'">
        <div class="container" id="app">
            <div class="mt-30 ma-tb-30">
                <div class="c-fff mb-10 b-b-fff pb-10 c-p" v-for="(item,index) in dataList" :key="index" @click="toDetail(item.Id)">
                    <div class="flex f-between w-100 pa-t-10 fs-4">
                        <div>{{item.Name}}</div>
                        <div>{{item.Status}}</div>
                    </div>
                    <div class="flex f-between ma-tb-10 w-100 c-4d4d4d">
                        <div>{{item.ViewCount}}人查阅</div>
                        <div>{{item.SaleCount}}人购买</div>
                    </div>
                </div>
            </div>
            <div class="t-center">
                <el-pagination layout="prev, pager, next" :total="TotalCount" background @current-change="currentChange" @prev-click="currentChange" @next-click="currentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";


    .box-body {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100vh;
        background-color: #000;
    }
    .b-b-fff{
        border-bottom: 1px solid #e9e9e9;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #FB004D !important;
    }
</style>
<script>
    import {getVodTicket} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                dataList: [],
                TotalCount:0,
                pageIndex:1,
                footbottom:123,
            };
        },
        created() {
            console.log("开始开发")
            this.loadData();
            this.$nextTick(() => {
                if(document.getElementById("mergefoot").scrollHeight!=null&&document.getElementById("mergefoot").scrollHeight>0){
                    this.footbottom=document.getElementById("mergefoot").scrollHeight;
                }
            })
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            //获取数据
            loadData() {
                let data = {
                    pageSize:10,
                    pageIndex:this.pageIndex,
                };
                getVodTicket(data).then((res) => {
                    console.log(res);
                    this.dataList = res.data.Data.List
                    this.TotalCount=res.data.Data.TotalCount
                });
            },
            toDetail(val){
                this.$router.push("/merge/movie?id="+val);
            },
        },
    };
</script>
